export default "__VITE_ASSET__87b4ad7c__"